document.documentElement.classList.remove('no-js');

// Mobile menu
const toggle = document.querySelector('[data-menu-toggle]');
const nav = document.querySelector('[data-mobile-nav]');
if (toggle && nav) {
  toggle.addEventListener('click', () => {
    const open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
}

// Progressive enhancement: normalize Quadrajet code searches without blocking native Shopify search.
document.querySelectorAll('form[role="search"], .search-page-form').forEach(form => {
  form.addEventListener('submit', () => {
    const input = form.querySelector('input[name="q"]');
    if (input) input.value = input.value.trim().replace(/\s+/g, ' ');
  });
});

// Product page: variant select updates price, compare-at, SKU, and button state.
document.querySelectorAll('[data-variant-select]').forEach(select => {
  const info = select.closest('.product-info');
  if (!info) return;
  select.addEventListener('change', () => {
    const opt = select.selectedOptions[0];
    if (!opt) return;
    const price = info.querySelector('[data-price]');
    const compare = info.querySelector('[data-compare-price]');
    const skuWrap = info.querySelector('[data-sku]');
    const button = info.querySelector('[data-add-button]');
    if (price) price.textContent = opt.dataset.price || '';
    if (compare) {
      compare.textContent = opt.dataset.comparePrice || '';
      compare.hidden = !opt.dataset.comparePrice;
    }
    if (skuWrap) {
      const span = skuWrap.querySelector('span');
      if (span) span.textContent = opt.dataset.sku || '';
      skuWrap.hidden = !opt.dataset.sku;
    }
    if (button) button.disabled = opt.dataset.available !== 'true';
  });
});

// Product gallery thumbnails
document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
  const main = gallery.querySelector('[data-main-image]');
  gallery.querySelectorAll('[data-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      if (!main) return;
      main.src = thumb.dataset.full;
      main.removeAttribute('srcset');
      gallery.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });

  // Image zoom: hover to magnify (desktop), click/tap to open full-size lightbox
  const frame = gallery.querySelector('.product-gallery__main');
  if (main && frame) {
    frame.classList.add('is-zoomable');
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (canHover) {
      frame.addEventListener('mousemove', e => {
        const r = frame.getBoundingClientRect();
        const x = ((e.clientX - r.left) / r.width) * 100;
        const y = ((e.clientY - r.top) / r.height) * 100;
        main.style.transformOrigin = x + '% ' + y + '%';
        main.style.transform = 'scale(2)';
      });
      frame.addEventListener('mouseleave', () => {
        main.style.transform = '';
        main.style.transformOrigin = '';
      });
    }
    frame.addEventListener('click', () => {
      const overlay = document.createElement('div');
      overlay.className = 'image-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-label', 'Enlarged product image');
      const big = document.createElement('img');
      big.src = main.currentSrc || main.src;
      big.alt = main.alt || '';
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'image-lightbox__close';
      close.setAttribute('aria-label', 'Close');
      close.textContent = '×';
      overlay.appendChild(big);
      overlay.appendChild(close);
      const dismiss = () => {
        overlay.remove();
        document.removeEventListener('keydown', onKey);
        document.body.style.overflow = '';
      };
      const onKey = e => { if (e.key === 'Escape') dismiss(); };
      overlay.addEventListener('click', dismiss);
      document.addEventListener('keydown', onKey);
      document.body.appendChild(overlay);
      document.body.style.overflow = 'hidden';
      close.focus();
    });
  }
});

// Collection sorting
document.querySelectorAll('[data-sort-select]').forEach(select => {
  select.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
});

// Login page: reveal password recovery form (also when linked with #recover).
const recoverToggle = document.querySelector('[data-recover-toggle]');
const recoverForm = document.getElementById('recover');
if (recoverToggle && recoverForm) {
  const show = () => { recoverForm.hidden = false; recoverForm.scrollIntoView({ behavior: 'smooth', block: 'center' }); };
  recoverToggle.addEventListener('click', e => { e.preventDefault(); show(); });
  if (window.location.hash === '#recover') show();
}

// Address forms: theme-owned country/province logic.
// all_country_option_tags renders each <option> with a data-provinces JSON attribute.
document.querySelectorAll('[data-address-country]').forEach(country => {
  const form = country.closest('form');
  const province = form && form.querySelector('[data-address-province]');
  const wrap = form && form.querySelector('[data-address-province-wrap]');
  if (!province) return;

  const defCountry = country.dataset.default;
  if (defCountry) [...country.options].forEach(o => { if (o.value === defCountry || o.text === defCountry) o.selected = true; });

  const updateProvinces = () => {
    const opt = country.selectedOptions[0];
    let provinces = [];
    try { provinces = JSON.parse(opt && opt.dataset.provinces || '[]'); } catch (e) { provinces = []; }
    province.innerHTML = '';
    if (!provinces.length) {
      if (wrap) wrap.hidden = true;
      province.disabled = true;
      return;
    }
    provinces.forEach(([value, label]) => {
      const o = document.createElement('option');
      o.value = value;
      o.textContent = label;
      province.appendChild(o);
    });
    const defProvince = province.dataset.default;
    if (defProvince) [...province.options].forEach(o => { if (o.value === defProvince || o.text === defProvince) o.selected = true; });
    if (wrap) wrap.hidden = false;
    province.disabled = false;
  };

  country.addEventListener('change', updateProvinces);
  updateProvinces();
});

// Subtle reveal animations (respects theme setting via body class and reduced motion).
if (document.body.classList.contains('reveal-enabled') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && 'IntersectionObserver' in window) {
  const targets = document.querySelectorAll('.category-card, .product-card, .step-card, .process-step, .testimonial, .trust-item, .article-card');
  const io = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -40px 0px', threshold: 0.1 });
  targets.forEach(el => { el.classList.add('will-reveal'); io.observe(el); });
}

// Hero slideshow: fade between slides, arrows, dots, autoplay (paused for reduced motion).
document.querySelectorAll('[data-hero-slider]').forEach(slider => {
  const slides = slider.querySelectorAll('[data-hero-slide]');
  if (slides.length < 2) return;
  const dotsWrap = slider.querySelector('[data-hero-dots]');
  let index = 0;
  let timer = null;
  const interval = Math.max(4, parseInt(slider.dataset.autoplay, 10) || 6) * 1000;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const dots = [];
  if (dotsWrap) {
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      dot.addEventListener('click', () => { go(i); restart(); });
      dotsWrap.appendChild(dot);
      dots.push(dot);
    });
  }

  function go(i) {
    index = (i + slides.length) % slides.length;
    slides.forEach((s, n) => s.classList.toggle('is-active', n === index));
    dots.forEach((d, n) => d.classList.toggle('is-active', n === index));
  }
  function restart() {
    if (timer) clearInterval(timer);
    if (!reduced) timer = setInterval(() => go(index + 1), interval);
  }

  const prev = slider.querySelector('[data-hero-prev]');
  const next = slider.querySelector('[data-hero-next]');
  if (prev) prev.addEventListener('click', () => { go(index - 1); restart(); });
  if (next) next.addEventListener('click', () => { go(index + 1); restart(); });
  slider.addEventListener('mouseenter', () => { if (timer) clearInterval(timer); });
  slider.addEventListener('mouseleave', restart);

  go(0);
  restart();
});

// Quick View modal
(function () {
  var overlay = null;
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : String(s);
    return d.innerHTML;
  }
  function close() {
    if (overlay) { overlay.remove(); overlay = null; document.removeEventListener('keydown', onKey); }
  }
  function onKey(e) { if (e.key === 'Escape') close(); }
  function open(product, url, priceHtml) {
    close();
    var img = product.images && product.images.length ? product.images[0] : null;
    var variantOptions = product.variants.map(function (v) {
      return '<option value="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' +
        esc(v.title === 'Default Title' ? product.title : v.title) + ' — ' + money(v.price) +
        (v.available ? '' : ' (sold out)') + '</option>';
    }).join('');
    var descDiv = document.createElement('div');
    descDiv.innerHTML = product.description || '';
    var descText = (descDiv.textContent || '').trim().slice(0, 400);
    overlay = document.createElement('div');
    overlay.className = 'qv-overlay';
    /* RNR 2026-09-07: priceHtml is the theme-rendered price block copied from the
       originating product card, so wholesale customers see the same labeled
       Retail/Wholesale display in Quick View. Falls back to plain price. */
    overlay.innerHTML =
      '<div class="qv-modal" role="dialog" aria-modal="true" aria-label="' + esc(product.title) + '">' +
        '<button type="button" class="qv-modal__close" aria-label="Close">×</button>' +
        '<div class="qv-modal__media">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(product.title) + '">' : '') + '</div>' +
        '<div class="qv-modal__info">' +
          '<h3 class="qv-modal__title">' + esc(product.title) + '</h3>' +
          '<div class="qv-modal__price">' + (priceHtml || money(product.price)) + '</div>' +
          (descText ? '<div class="qv-modal__desc">' + esc(descText) + (descText.length >= 400 ? '…' : '') + '</div>' : '') +
          '<form method="post" action="/cart/add">' +
            (product.variants.length > 1
              ? '<select name="id">' + variantOptions + '</select>'
              : '<input type="hidden" name="id" value="' + product.variants[0].id + '">') +
            '<button class="button button--red button--full" type="submit"' + (product.available ? '' : ' disabled') + '>' +
              (product.available ? 'ADD TO CART' : 'SOLD OUT') + '</button>' +
          '</form>' +
          '<a class="qv-modal__link" href="' + esc(url) + '">View full details →</a>' +
        '</div>' +
      '</div>';
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.closest('.qv-modal__close')) close();
    });
    document.body.appendChild(overlay);
    document.addEventListener('keydown', onKey);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quickview]');
    if (!btn) return;
    e.preventDefault();
    var url = btn.getAttribute('data-quickview');
    var card = btn.closest('.product-card');
    var priceEl = card && card.querySelector('.product-card__price');
    var priceHtml = priceEl ? priceEl.innerHTML : '';
    fetch(url.split('?')[0] + '.js')
      .then(function (r) { if (!r.ok) throw new Error('load failed'); return r.json(); })
      .then(function (p) { open(p, url, priceHtml); })
      .catch(function () { window.location.href = url; });
  });
  // Close modal after a successful drawer add so the drawer is visible
  document.addEventListener('submit', function (e) {
    if (overlay && e.target.closest && e.target.closest('.qv-modal')) {
      setTimeout(close, 400);
    }
  });
})();

/* Homepage strip carousels: arrows page through the product rows */
(function () {
  function grid(sc) { return sc.querySelector('.products-grid--strip'); }
  function update(sc) {
    var g = grid(sc); if (!g) return;
    var prev = sc.querySelector('.strip-arrow--prev');
    var next = sc.querySelector('.strip-arrow--next');
    var max = g.scrollWidth - g.clientWidth;
    var overflow = max > 4;
    if (prev) prev.hidden = !overflow || g.scrollLeft <= 2;
    if (next) next.hidden = !overflow || g.scrollLeft >= max - 2;
  }
  function refreshAll() {
    document.querySelectorAll('.strip-scroller').forEach(update);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.strip-arrow');
    if (!btn) return;
    var sc = btn.closest('.strip-scroller');
    var g = sc && grid(sc); if (!g) return;
    var card = g.querySelector('.product-card');
    var step = card ? card.getBoundingClientRect().width + 14 : 280;
    g.scrollBy({ left: (btn.classList.contains('strip-arrow--next') ? 1 : -1) * step, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('products-grid--strip')) update(t.closest('.strip-scroller'));
  }, true);
  window.addEventListener('resize', refreshAll);
  function observeStrips() {
    // The garage fitment filter toggles `hidden` on cards, changing each
    // strip's scrollWidth — watch for that and re-evaluate the arrows.
    document.querySelectorAll('.products-grid--strip').forEach(function (g) {
      new MutationObserver(function () {
        var sc = g.closest('.strip-scroller');
        if (sc) update(sc);
      }).observe(g, { attributes: true, attributeFilter: ['hidden', 'style', 'class'], subtree: true });
    });
  }
  function init() { refreshAll(); observeStrips(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();


/* Product gallery controls: arrows, thumbnail sync, and touch swipe. */
(function () {
  function initProductGallery(gallery) {
    if (gallery.dataset.galleryControlsReady === 'true') return;
    var main = gallery.querySelector('[data-main-image]');
    var frame = gallery.querySelector('.product-gallery__main');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    if (!main || !frame || thumbs.length < 2) return;
    gallery.dataset.galleryControlsReady = 'true';

    var index = Math.max(0, thumbs.findIndex(function (thumb) {
      return thumb.classList.contains('is-active');
    }));

    function show(nextIndex) {
      index = (nextIndex + thumbs.length) % thumbs.length;
      var thumb = thumbs[index];
      main.src = thumb.dataset.full;
      main.removeAttribute('srcset');
      thumbs.forEach(function (item, itemIndex) {
        item.classList.toggle('is-active', itemIndex === index);
        item.setAttribute('aria-current', itemIndex === index ? 'true' : 'false');
      });
      thumb.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'});
    }

    thumbs.forEach(function (thumb, thumbIndex) {
      thumb.addEventListener('click', function () { index = thumbIndex; });
    });

    var previous = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (previous) previous.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      show(index - 1);
    });
    if (next) next.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      show(index + 1);
    });

    var touchStartX = null;
    frame.addEventListener('touchstart', function (event) {
      touchStartX = event.changedTouches[0].clientX;
    }, {passive: true});
    frame.addEventListener('touchend', function (event) {
      if (touchStartX === null) return;
      var delta = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(delta) < 45) return;
      show(delta < 0 ? index + 1 : index - 1);
    }, {passive: true});
  }

  function initAllProductGalleries() {
    document.querySelectorAll('[data-product-gallery]').forEach(initProductGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProductGalleries);
  } else {
    initAllProductGalleries();
  }
})();
